<template>
  <main>
    <b-container v-if="currentProject">
      <div class="page-breadcrumb">
        <router-link
          v-if="currentProject"
          :to="{ name: 'ProjectView', params: { id: currentProject._id } }"
        >
          <i class="fa fa-angle-left" /> Back to project:
          {{ currentProject.name }}
        </router-link>
      </div>

      <div class="section-header">
        <h1 class="heading">Create model</h1>

        <div class="actions"></div>
      </div>

      <div class="layoutcard">
        <b-row>
          <b-col cols="8" lg="7">
            <ModelForm
              :form="form"
              :configForm="configForm"
              :pool-selection-visible="true"
              @callback="submit"
            ></ModelForm>
          </b-col>
          <b-col class="text-center">
            <b-img
              src="/images/add-pool.svg"
              class="my-2"
              width="180"
              alt="Add pool to model"
              title="Add pool to model"
            ></b-img>
            <p class="my-3 px-4">
              Want to create a new pool?
              <br/> Click the button below to make a new
              pool.
            </p>
            <b-btn
              variant="outline-secondary"
              @click.prevent="newPool"
            >
              <i class="fa fa-plus" /> Add New Pool
            </b-btn>
          </b-col>
        </b-row>
      </div>
    </b-container>
  </main>
</template>

<script>
import _ from "lodash";
import { mapActions } from "vuex";
import InitAdmin from "../Shared/InitAdmin";
import ModelForm from "./ModelForm";

export default {
  name: "ModelCreate",
  components: {
    ModelForm,
  },
  extends: InitAdmin,
  data() {
    return {
      currentProject: null,
      form: {
        name: null,
        description: null,
        pools: [],
        configOptions: false
      },
      configForm: {
        lowerLimit: null,
        upperLimit: null,
        ratio: null,
        maxWordCount: null,
        numberOfWords: null,
        numberOfFields: null,
      }
    };
  },
  mounted() {
    this.loadPools();
    this.loadProject({ id: this.$route.params.projectId }).then((res) => {
      this.currentProject = res;
    });
  },
  methods: {
    ...mapActions(["loadPools", "loadProject", "addModelToProject"]),
    submit() {
      this.$validator.validateAll().then((result) => {
        if (!result) {
          this.$toasted.show(this.$validator.errors.items[0].msg, {
            type: "error",
          });
          return;
        }

        const data = [];
        data.projectId = this.currentProject._id;
        data.pool_ids = this.form.pools;
        data.topicing_method = "internal";
        data.name = this.form.name;
        data.description =
          this.form.description === null ? "NA" : this.form.description;
        this.addModelToProject(data).then((res) => {
          if(this.form.configOptions){
            let modelId = _.last(res.projectModels);
            console.log(modelId);
            //this.submitSettings(modelId)
          }
          else{
            this.$toasted.show("Model Added to Project");
            setTimeout(() => {
              this.$router.push({
                name: "ProjectView",
                params: { id: this.currentProject._id },
              });
            }, 1000);
          }
        });
      });
    },
    submitSettings(res){

    },
    newPool() {
      this.$router.push({
        name: "PoolCreate",
        params: { ref: this.currentProject._id },
      });
    },
  },
};
</script>
